<div class="table-wrapper">
  <!-- Loading State -->
  <div *ngIf="isLoading" class="loading-container">
    <qai-loading [size]="'medium'"></qai-loading>
  </div>

  <!-- Status filter + Search -->
  @if (!isLoading) {
    <div class="filter-container">
      <qai-searchable-select
        [shape]="'rectangle'"
        [placement]="'below-start'"
        [offset]="4"
        [placeholder]="'simulationBuilder.SIMULATION_STATUS_PLACEHOLDER' | transloco"
        [searchable]="false"
        [options]="statusOptions"
        [multiselect]="true"
        [value]="selectedStatusValues"
        [disabled]="hasNoSimulations"
        (valueChange)="onStatusFilterChange($event)"
        [selectionPrefix]="'simulationBuilder.SIMULATION_STATUS_PREFIX' | transloco"
        [scopedOptionsSelectionMode]="visibleOptionsSelectionMode"
        [othersTextFormatter]="othersTextFormatter"
      ></qai-searchable-select>

      <div class="search-input-wrapper">
        <qai-field [label]="''">
          <qai-icon kind="search-lg" qaiSlot="startIcon" />
          <input
            qai-input
            size="lg"
            type="text"
            [placeholder]="'simulationBuilder.SEARCH_BY_SIMULATION_NAME' | transloco"
            [value]="searchName()"
            (input)="onSearchNameChange($event)"
          />
        </qai-field>
      </div>
    </div>
  }

  <!-- Empty State -->
  <div *ngIf="!isLoading && tableData.length === 0" class="empty-container">
    <p>{{ 'simulationBuilder.NO_SIMULATIONS_FOUND' | transloco }}</p>
  </div>

  <!-- Data Loaded State -->
  <qai-table
    *ngIf="!isLoading && tableData.length > 0"
    [headers]="headers"
    [data]="tableData"
    [striped]="false"
    [currentPage]="currentPage"
    (rowAction)="onTableRowAction($event)"
    (rowClick)="onTableRowClick($event)"
    [isTooltipLoading]="isTooltipLoading"
    (tooltipDataRequested)="onTooltipDataRequested($event)"
    (pageChanged)="onPageChanged($event)"
    [initialSortColumn]="initialSortColumn"
    [initialSortDirection]="initialSortDirection"
    [previousLabel]="'simulationBuilder.PAGINATION_PREVIOUS' | transloco"
    [nextLabel]="'simulationBuilder.PAGINATION_NEXT' | transloco"
  ></qai-table>
</div>

<edit-simulation-tags-modal
  [open]="isEditTagsModalOpen"
  [simulation]="editTagsSimulation"
  (saved)="onSimulationTagsSaved()"
  (closeModal)="onEditTagsModalClosed()"
></edit-simulation-tags-modal>
